import { render, staticRenderFns } from "./TabUserNftItem.vue?vue&type=template&id=1a38b578"
import script from "./TabUserNftItem.vue?vue&type=script&lang=js"
export * from "./TabUserNftItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports